// Mã căn thân thiện cho link /sale?room=... — {buildingCode}{room.number} (vd "HHT501", "BC201") thay
// vì Firestore doc ID random (vd "PR8wbyRG2bWbHQOHaj8d"). Thuần hàm string, KHÔNG phụ thuộc Firebase/
// Node — an toàn import cả client ('use client' app/sale/page.tsx) lẫn server (API routes Admin SDK).
//
// Khác `aptCode` (types/index.ts, vd "HHT51") — đó là mã NGẮN (tầng+unit) chỉ dùng nội bộ cho Channex
// room mapping, không liên quan gì tới alias công khai này (alias dùng ĐÚNG số phòng thật, không rút
// gọn, để không phụ thuộc toà đã nối Channex hay chưa).

export function roomAlias(buildingCode: string, roomNumber: string): string {
  return `${buildingCode}${roomNumber}`;
}

// Khớp alias ngược lại với danh sách buildingCode đã biết của tenant — ưu tiên code DÀI NHẤT trước
// (phòng trường hợp tenant có cả code "B" lẫn "BC", tránh "B" nuốt nhầm phần đầu "BC201").
export function parseRoomAlias(alias: string, buildingCodes: string[]): { buildingCode: string; roomNumber: string } | null {
  const sorted = [...buildingCodes].sort((a, b) => b.length - a.length);
  for (const code of sorted) {
    if (alias.startsWith(code) && alias.length > code.length) {
      return { buildingCode: code, roomNumber: alias.slice(code.length) };
    }
  }
  return null;
}
